import { FaCheckCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';

export default function AccordionCard({ open, onClick, step, completed, label, children }) {
  return (
    <div className="mb-0 overflow-hidden rounded-xl border border-[#E5E7EB] bg-white">
      <div
        className={`flex cursor-pointer select-none items-center px-6 py-[1.25rem] ${open ? '' : 'border-b-0'}`}
        onClick={onClick}
      >
        <div className="mr-[1rem] flex items-center">
          {completed ? (
            <FaCheckCircle className="mr-[0.5rem] size-[1.625rem] text-xl text-therablue" />
          ) : (
            <span className="mr-[0.5rem] flex h-[1.75rem] w-[1.75rem] items-center justify-center rounded-full bg-[#181818] text-[1.125rem] font-bold text-white">
              {step}
            </span>
          )}
        </div>
        <span className="text-[1.25rem] font-bold text-[#181818]">{label}</span>
        <span className="ml-auto">
          {open ? <FaChevronUp className="text-[#181818]" /> : <FaChevronDown className="text-[#181818]" />}
        </span>
      </div>
      {open && <div className="border-t border-[#E5E7EB] bg-white px-6 pb-[1.5rem] pt-[0.5rem]">{children}</div>}
    </div>
  );
}
